import React, { useState } from 'react';
import CommentItem from './CommentItem';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CommentSection = ({ comments, onAddComment }) => {
  const [commentText, setCommentText] = useState('');
  const [sortBy, setSortBy] = useState('recent');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (commentText?.trim()) {
      onAddComment(commentText);
      setCommentText('');
    }
  };

  const handleLike = (commentId) => {
    console.log('Like comment:', commentId);
  };

  const handleReply = (commentId) => {
    console.log('Reply to comment:', commentId);
  };

  const handleReport = (commentId) => {
    console.log('Report comment:', commentId);
  };

  const sortedComments = [...comments]?.sort((a, b) => {
    if (sortBy === 'recent') {
      return new Date(b.timestamp) - new Date(a.timestamp);
    } else if (sortBy === 'popular') {
      return b?.likes - a?.likes;
    }
    return 0;
  });

  return (
    <div className="bg-card">
      <div className="border-b border-border p-4 md:p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-h5 font-heading">
            Comments ({comments?.length})
          </h3>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setSortBy('recent')}
              className={`caption px-3 py-1.5 rounded-lg transition-base ${
                sortBy === 'recent' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Recent
            </button>
            <button
              onClick={() => setSortBy('popular')}
              className={`caption px-3 py-1.5 rounded-lg transition-base ${
                sortBy === 'popular' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Popular
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="flex gap-3">
          <div className="flex-1 relative">
            <input
              type="text"
              value={commentText}
              onChange={(e) => setCommentText(e?.target?.value)}
              placeholder="Add a comment..."
              className="w-full px-4 py-3 bg-muted border border-border rounded-xl text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-base text-sm md:text-base"
              aria-label="Add a comment"
            />
          </div>
          <Button
            type="submit"
            variant="default"
            size="default"
            disabled={!commentText?.trim()}
            iconName="Send"
            iconPosition="right"
            className="flex-shrink-0"
          >
            <span className="hidden md:inline">Post</span>
          </Button>
        </form>
      </div>
      <div className="divide-y divide-border">
        {sortedComments?.length > 0 ? (
          sortedComments?.map((comment) => (
            <div key={comment?.id} className="p-4 md:p-6">
              <CommentItem
                comment={comment}
                onLike={handleLike}
                onReply={handleReply}
                onReport={handleReport}
              />
            </div>
          ))
        ) : (
          <div className="p-8 md:p-12 text-center">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="MessageCircle" size={32} color="var(--color-muted-foreground)" />
            </div>
            <p className="text-muted-foreground caption">
              No comments yet. Be the first to comment!
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentSection;